<script lang="ts" setup>
import ProblemPresentationCard from '../ProblemPresentation/ProblemPresentationCard.vue';

defineProps<{
  imageNumber: InstanceType<
    typeof ProblemPresentationCard
  >['$props']['imageNumber'];
}>();
</script>

<template>
  <ProblemPresentationCard :image-number="imageNumber">
    <template #titleText>
      iDeCoを<span :class="$style['card__text--accent']">始めたい</span>けど不安
    </template>
    <template #detail>
      iDeCoを始めたいけど、手続きが複雑そう。何から始めればいいのか、具体的に教えてほしい。
    </template>
  </ProblemPresentationCard>
</template>

<style lang="scss" module>
.card {
  &__text {
    &--accent {
      color: $color-text-and-object-accent-primary;
    }
  }
}
</style>
